import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import ContractRefundStatusCode from 'models/enums/ContractRefundStatusCode';
import { useContractRefundProvider } from '../Sales.ContractRefund.Hooks';
import { cleanValues } from 'assets/utils/data/Object';

export default function SalesContractRefundFilters() {
  const { lang, translate } = getLocales();
  const { isDealer, isDistributor } = useAuthStore();
  const { listApi, dealerListApi, distributorListApi, userListApi, pageRouter } = useContractRefundProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      onSortById={(sort) =>
        pageRouter.updateQuery({
          ...pageRouter.query,
          list: cleanValues({
            ...pageRouter.query?.list,
            ...sort,
          }),
        })
      }
      search={listApi.body?.search}
      onSearch={(search) =>
        pageRouter.updateQuery({
          ...pageRouter.query,
          list: cleanValues({
            ...pageRouter.query?.list,
            search,
            offset: 0,
          }),
        })
      }
      filters={listApi.body}
      onFilter={(newFilters) =>
        pageRouter.redirect(
          { ...pageRouter.params, action: undefined },
          {
            ...pageRouter.query,
            list: {
              ...newFilters,
              offset: 0,
            },
          }
        )
      }
      onReset={() => {
        pageRouter.redirect(
          { ...pageRouter.params, action: undefined },
          {
            ...pageRouter.query,
            list: undefined,
          }
        );
      }}
      onOpen={() => {
        if (!dealerListApi.payload) dealerListApi.execute((body) => body);
        if (!distributorListApi.payload) distributorListApi.execute((body) => body);
        if (!userListApi.payload) userListApi.execute((body) => body);
      }}
      render={({ tempFilters, setFilters }) => {
        return (
          <>
            <SelectInput
              name="statusCode"
              label={lang.status}
              data={Object.values(ContractRefundStatusCode).map((it) => ({
                id: it,
                title: translate(it),
                icon: <Icon class="fas-check" />,
              }))}
              isMultiselect
              value={tempFilters?.statusCode}
              onChange={setFilters}
              icon={<Icon class="fas-cloud" />}
            />
            <SelectInput
              name="dealerId"
              label={lang.dealers}
              data={dealerListApi?.payload?.data?.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-user" />,
              }))}
              isMultiselect
              value={tempFilters?.dealerId}
              disabled={!dealerListApi?.payload?.data?.length}
              onChange={setFilters}
              icon={<Icon class="fas-user" />}
            />
            {!isDealer && !isDistributor && (
              <SelectInput
                name="distributorId"
                label={lang.distributors}
                data={distributorListApi?.payload?.data?.map((item) => ({
                  ...item.displayInfo,
                  icon: <Icon class="fas-cloud" />,
                }))}
                isMultiselect
                value={tempFilters?.distributorId}
                disabled={!distributorListApi?.payload?.data?.length}
                onChange={setFilters}
                icon={<Icon class="fas-cloud" />}
              />
            )}
            <SelectInput
              name="createdById"
              label={lang.initiatedBy}
              data={userListApi?.payload?.data?.map((user) => ({
                id: user.id,
                title: user.fullName,
                icon: <Icon class="fas-user" />,
              }))}
              isMultiselect
              disabled={!userListApi?.payload?.data?.length}
              value={tempFilters?.createdById}
              onChange={setFilters}
              icon={<Icon class="fas-user" />}
            />
            <InputWrapper style={{ gridColumn: 'span 2', height: 'fit-content', marginTop: 'var(--sizeM)' }}>
              <DateInput
                name="createdAtFromDateUtc"
                label={lang.createdAtFromDate}
                dateTimeFormat={defaultInputDateTimeFormat}
                value={tempFilters?.createdAtFromDateUtc}
                onChange={setFilters}
                icon={<Icon class="fas-calendar-alt" />}
              />
              <DateInput
                name="createdAtToDateUtc"
                label={lang.createdAtToDate}
                dateTimeFormat={defaultInputDateTimeFormat}
                value={tempFilters?.createdAtToDateUtc}
                onChange={setFilters}
                icon={<Icon class="fas-calendar-alt" />}
              />
            </InputWrapper>
          </>
        );
      }}
    />
  );
}
